import { MorphemeSelectionOverlayContent } from "#morpheme-selection-overlay-content";
import { useMorphemeSelectionOverlayContentGate } from "#use-morpheme-selection-overlay-content-gate";

/**
 * App-wide bottom action bar for morpheme and exact-user-card selection. Mount once near the app
 * layout root (inside `AppLayoutContextProvider`, whose `isSelecting` drives it) so it floats over
 * whichever screen the selected surfaces live on.
 *
 * The bar mounts for as long as its gate is open: from selection start until its slide-out has
 * finished. It slides itself in and out with a manual `translateY` transform, which is what keeps
 * its top edge flush with the tab bar: a reanimated `entering`/`exiting` layout animation (what
 * this used to use) can be frozen mid-flight by a Fabric commit and leaves a permanent few-point
 * gap above the bar. See `use-morpheme-selection-overlay-slide.ts`.
 */
export function MorphemeSelectionOverlay() {
  const contentGate = useMorphemeSelectionOverlayContentGate();

  return <>{contentGate !== null && <MorphemeSelectionOverlayContent gate={contentGate} />}</>;
}
